import HTTPService from '~/services/HTTPService';

export default (ctx, inject) => {
  inject('HTTP', new HTTPService(ctx));
};
